(function () {
  "use strict";
  var L = window.Lagom;
  if (!(!L || !L.q)) {
    var q = L.q,
      qa = L.qa,
      motionOff = L.motionOff,
      MOTION = L.MOTION,
      CAPTURE = L.CAPTURE,
      IMG = L.assetBase || "";
    (function () {
      var track = q(".press__track");
      if (!track || motionOff() || !track.getAnimations) return;
      function anim() {
        return track.getAnimations()[0];
      }
      function rate(r) {
        var a = anim();
        a &&
          (a.updatePlaybackRate
            ? a.updatePlaybackRate(r)
            : (a.playbackRate = r));
      }
      (track.addEventListener("mouseenter", function () {
        rate(0.3);
      }),
        track.addEventListener("mouseleave", function () {
          rate(1);
        }),
        "IntersectionObserver" in window &&
          new IntersectionObserver(function (entries) {
            var a = anim();
            a && (entries[0].isIntersecting ? a.play() : a.pause());
          }).observe(track));
    })();
  }
})();

